module.exports = __webpack_public_path__ + "img/pencil-write-3-alternate.769c07cf.svg";